export default __webpack_public_path__ + "static/media/Kurt-Holle2.0e84a7c7.jpg";